import { getTreatmentsExtensionForGraphqlBody } from '@ms/yammer-data/dist/api';
import { getClientForwardExperiments } from '@ms/yammer-data/dist/domains/experiments/selectors';
import type { Store } from '@ms/yammer-data/dist/state/types';
import type { LazyRelayAppWrapperProps } from '@ms/yammer-relay/dist/environment';
import type { YammerTeamsState } from 'state/types';

import config from '../../bootstrap/config';

export const getLazyRelayAppWrapperProps = (
  store: Store<YammerTeamsState>,
  etag?: string
): LazyRelayAppWrapperProps => {
  const state = store.getState();

  const experiments = getClientForwardExperiments(state);
  const treatments = getTreatmentsExtensionForGraphqlBody({
    state,
    experiments: [...experiments, 'CommunityAgentAdmin', 'CommunityAgentPrivatePreview', 'CommunityAgentPublicPreview'],
  });

  return {
    authScope: config.adal.resources.yammer,
    host: config.hosts.graphql,
    treatments,
    etag,
  };
};
